import React from "react";

export default function SQLServer_UPPER() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_UPPER</h1>
      <p>This is the SQLServer_UPPER component generated from the SQL JSON.</p>
    </div>
  );
}
